import toast from 'react-hot-toast';

import { affiliateThemeByService } from '@repo/styles';

import Toast, { ToastProps as HandleToastParams } from 'components/Toast';

// Custom function
const handleToast = ({ icon, message, id, $isSuccess, $shape, $duration, $style }: HandleToastParams) => {
  toast.custom(
    <Toast
      icon={icon}
      message={message}
      $isSuccess={$isSuccess}
      $shape={$shape}
      $duration={$duration}
      $style={$style}
    />,
    {
      duration: $duration,
      position: $shape === 'long' || $shape === 'top-center' ? 'top-center' : 'bottom-center',
      id,
    }
  );
  setTimeout(() => toast.remove(), $duration);
};

export const handleSuccessToast = (
  message: React.ReactNode,
  icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>
) =>
  handleToast({
    message: message,
    $isSuccess: true,
    $shape: 'long',
    $duration: 1000,
    icon: icon,
  });

export const handleFailToast = (
  message: React.ReactNode,
  icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>
) =>
  handleToast({
    message: message,
    $isSuccess: false,
    $shape: 'long',
    $duration: 3000,
    icon: icon,
  });

export const handleShortToast = (
  message: React.ReactNode,
  icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>
) => {
  handleToast({
    message: message,
    $isSuccess: true,
    $shape: 'short',
    $duration: 3000,
    icon: icon,
  });
};

export const handleShortFailToast = (
  message: React.ReactNode,
  icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>
) => {
  handleToast({
    message: message,
    $isSuccess: false,
    $shape: 'short',
    $duration: 3000,
    icon: icon,
  });
};
export const handleShortToastComment = (message: string, boxHeight?: number) => {
  handleToast({
    message: message,
    $isSuccess: true,
    $shape: 'short',
    $duration: 3000,
    $style: {
      borderRadius: 10,
      background: 'rgba(0, 0, 0, 0.70)',
      padding: '15px 20px',
      fontSize: 15,
      fontWeight: 500,
      lineHeight: '20px',
      marginBottom: boxHeight || 0,
      position: 'fixed',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: `calc(100vh - ${window.innerHeight}px + 30px)`,
    },
  });
};

export const handleShortToastChat = (message: string, boxHeight?: number) => {
  const isDarkMode = document.body.classList.contains('dark');
  return handleToast({
    message: message,
    $isSuccess: true,
    $shape: 'top-center',
    $duration: 3000,
    $style: {
      marginBottom: boxHeight || 0,
      padding: '14px 16px',
      width: 'fit-content',
      height: 'min-content',
      position: 'fixed',
      transform: 'translateX(-50%)',
      left: '50%',
      top: 30,
      display: 'flex',
      gap: 10,
      alignItems: 'center',
      background: isDarkMode
        ? affiliateThemeByService().color.field.toast.dark
        : affiliateThemeByService().color.field.toast.light,
      borderRadius: 8,
      color: affiliateThemeByService().color.static.white.light,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
    },
  });
};

export default handleToast;
